// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1711":"2478fcc0","2424":"3b5c53f6","9348":"3f00b7dd"}[chunkId] + ".chunk.css";
};